<template>
  <MATextarea
    v-model="input"
    :type="type"
    :rows="rows"
    :cols="cols"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :required="required"
    :custom-class="customClass"
  />
</template>

<script setup lang="ts">
import { ulid } from "ulid";
import MATextarea from "../primevueComponents/MATextarea.vue";

const props = withDefaults(
  defineProps<{
    type?: "email" | "text" | "phone";
    label?: string;
    modelValue?: string;
    disabled?: boolean;
    required?: boolean;
    readonly?: boolean;
    placeholder?: string;
    rules?: Record<string, any>;
    rows?: number;
    cols?: number;
    customClass?: string;
    maxTokenLength?: number;
  }>(),
  {
    id: ulid(),
    disabled: false,
    placeholder: "",
    modelValue: "",
    type: "text",
    rules: () => ({}),
    customClass: "",
  }
);

const emit = defineEmits(["update:modelValue", "blur"]);
const input = useVModel(props, "modelValue", emit);
</script>
